"use client";

import * as React from "react";
import { Chip as ShadcnChip, type ChipProps as ShadcnChipProps } from "../chip";
import { cn } from "@/lib/utils";

export interface ChipProps extends ShadcnChipProps {
  endContent?: React.ReactNode;
  classNames?: {
    base?: string;
    content?: string;
  };
}

const Chip = React.forwardRef<HTMLDivElement, ChipProps>(
  ({ endContent, classNames, className, children, ...props }, ref) => {
    return (
      <ShadcnChip
        ref={ref}
        className={cn(classNames?.base, className)}
        {...props}
      >
        <span className={cn(classNames?.content)}>{children}</span>
        {endContent && <span className="ml-1">{endContent}</span>}
      </ShadcnChip>
    );
  }
);
Chip.displayName = "Chip";

export { Chip };
